import { useState, useRef } from "react"
import PropTypes from "prop-types"
import { Button, Menu, MenuItem } from "@mui/material"
import { Compare, ArrowDropDown } from "@mui/icons-material"
import { useIsEndVsStartDateComparisonEnabled, useIsDashboardOptimizeExperimentsFeatureEnabled } from "resources/account"

export default function ComparisonMenu({ onInstrumentClick, onDateComparisonClick, isOptimizedExperimentsDrawerOpen, setIsOptimizedExperimentsDrawerOpen }) {
  const [isOpen, setIsOpen] = useState(false)
  const anchorRef = useRef(null)
  const isEndVsStartDateComparisonEnabled = useIsEndVsStartDateComparisonEnabled()
  const isOptimizeExperimentsEnabled = useIsDashboardOptimizeExperimentsFeatureEnabled()

  function handleToggle() {
    if (isEndVsStartDateComparisonEnabled || isOptimizeExperimentsEnabled) {
      setIsOpen(prev => !prev)
    } else {
      onInstrumentClick()
    }
  }

  function handleClose() {
    setIsOpen(false)
  }

  return (
    <>
      <Button
        ref={anchorRef}
        variant="text"
        onClick={handleToggle}
        className="search-comparison-wrapper"
        startIcon={<Compare />}
      >
        <div className="search-comparison-label-container">
          <span>Compare</span>
          {(isEndVsStartDateComparisonEnabled || isOptimizeExperimentsEnabled) && <ArrowDropDown />}
        </div>
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={() => {
          onInstrumentClick()
          handleClose()
        }}
        >
          Instrument
        </MenuItem>
        <MenuItem onClick={() => {
          onDateComparisonClick()
          handleClose()
        }}
        >
          End vs start date
        </MenuItem>
        {isOptimizeExperimentsEnabled && (
          <MenuItem onClick={() => {
            setIsOptimizedExperimentsDrawerOpen(!isOptimizedExperimentsDrawerOpen)
            handleClose()
          }}
          >
            Optimize Experiments
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

ComparisonMenu.propTypes = {
  onInstrumentClick: PropTypes.func.isRequired,
  onDateComparisonClick: PropTypes.func.isRequired,
  isEndVsStartDateComparisonEnabled: PropTypes.bool,
  isOptimizedExperimentsDrawerOpen: PropTypes.bool,
  setIsOptimizedExperimentsDrawerOpen: PropTypes.func,
}
